import React from "react"
import { Link } from "gatsby"
import "./indexCard.scss"

const IndexCard = ({ id, className, imageUrl, title, summary, createdAt }) => {
  return (
    <article key={id} className={`c-indexCard ${className}`}>
      <p className="c-indexCard-date">更新日：{createdAt}</p>
      <div className="c-indexCard-inner">
        <img
          src={imageUrl}
          alt="書籍イメージ画像"
          width="103"
          className="c-indexCard-image"
        />
        <div className="c-indexCard-description">
          <h2 className="c-indexCard-title">{title}</h2>
          <p className="c-indexCard-summary">{summary}</p>
          <Link to={`/post/${id}/`} className="c-indexCard-more">
            詳細を見る
          </Link>
        </div>
      </div>
    </article>
  )
}

export default IndexCard
